<h3  mat-dialog-title >Are you sure to switch?</h3>
<p>The data will be lost if switching between tabs.</p>

<div mat-dialog-actions>
    <button mat-raised-button mat-button color="primary" [mat-dialog-close]="data" (click)="confirm()">Confirm</button>  
    <button mat-raised-button mat-button color="primary" (click)="onNoClick()">Cancel</button>
</div>
